import {
  ImagePreviewer,
  type ImagePreviewerRef,
} from "@/components/FilePreviewer/ImagePreviewer";
import {
  DocumentPreviewer,
  type DocumentPreviewerRef,
} from "@/components/FilePreviewer/DocumentPreviewer";
import {
  VideoPreviewer,
  type VideoPreviewerRef,
} from "@/components/FilePreviewer/VideoPreviewer";
import { isImage, isVideo } from "@/utils/file";
import { createContext, useContext, useRef } from "react";

const FilePreviewContext = createContext<FilePreviewContextProps | null>(null);

interface FilePreviewContextProps {
  openPreview: (fileUrl: string) => void;
}

export const useFilePreview = () => {
  const context = useContext(FilePreviewContext);
  if (!context) {
    throw new Error("useFilePreview must be used within FilePreviewContext");
  }
  return context.openPreview;
};

export const FilePreviewProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const imagePreivewerRef = useRef<ImagePreviewerRef | null>(null);
  const documentPreivewerRef = useRef<DocumentPreviewerRef | null>(null);
  const videoPreivewerRef = useRef<VideoPreviewerRef | null>(null);

  const openPreview = (input: string) => {
    if (isImage(input)) {
      imagePreivewerRef.current?.openFilePreview(input);
    } else if (isVideo(input)) {
      videoPreivewerRef.current?.openFilePreview(input);
    } else {
      documentPreivewerRef.current?.openFilePreview(input);
    }
  };

  return (
    <FilePreviewContext.Provider value={{ openPreview }}>
      {children}
      {/* 预览图片 */}
      <ImagePreviewer ref={imagePreivewerRef} />
      {/* 预览视频 */}
      <VideoPreviewer ref={videoPreivewerRef} />
      {/* 预览除图片和视频外的其他文档 */}
      <DocumentPreviewer ref={documentPreivewerRef} />
    </FilePreviewContext.Provider>
  );
};
